<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">PC CON SOLICITUD VS PC SIN SOLICITUD</h1>
                <div class="caption">
                    Muestra el total de items de pedidos de compra, discriminando por items sin solicitud de compra e
                    items con solicitud de compra, por empresa y en el periodo seleccionado
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text class="text-xs-center">
                        <empresa-select v-model="d.empresa"></empresa-select>
                        <v-switch label="Quitar intercompany" v-model="d.intercompany"></v-switch>
                        <v-menu
                                lazy
                                full-width
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(d.desde)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                full-width
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                :return-value.sync="menuHasta"
                                ref="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="hasta"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(d.hasta)"
                            ></v-date-picker>
                        </v-menu>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import monedaSelect from '../../components/MonedaSelect.vue'
    import moment from 'moment'

    export default {
        components: {empresaSelect, monedaSelect},
        data() {
            return {
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                d: {
                    empresa: '',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD'),
                    intercompany: false
                },
                chartOptions: {
                    colors: ['#3b9d3b', '#D62C1A', '#ffdd32'],
                    chart: {
                        type: 'column',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'PC CON SOLICITUD VS PC SIN SOLICITUD'
                    },
                    legend: {
                        enabled: true,
                    },
                    xAxis: {
                        type: 'category',
                        minRange: 1
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            }
                        }
                    },
                    tooltip: {
                        pointFormat: '<span>{series.name}</span>: <b>{point.y:,.0f}%</b><br/>',
                    },
                    plotOptions: {
                        column: {
                            stacking: true,
                            dataLabels: {
                                align: 'left',
                                enabled: true,
                                color: '#ffffff',
                                style: {
                                    textShadow: '0 0 3px black, 0 0 3px black'
                                },
                                format: '{y}({point.percentage:.0f}%)'
                            }
                        },
                    },
                    series: []
                }
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/pedidos-compras', this.d)
                    .then(r => {
                        this.chartOptions.series = r.data;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        console.log(r)
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/pedidos-compras.vue